import { http } from 'services/http';
import type { TCreateTripReq, TEntityIdRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateTrip = () => {
  return useMutationBase<TEntityIdRes, unknown, TCreateTripReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TEntityIdRes>('/v1/trips', variables);

      return res.data;
    },
  });
};
